import { init, RematchRootState } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import loadingPlugin from '@rematch/loading';
import * as Sentry from '@sentry/browser';

import createSentryMiddleware from 'redux-sentry-middleware';

import { admin } from 'src/modules/admin/rematchModels/admin';
import { assessments } from 'src/modules/assessments/rematchModels/assessments';
import { authentication } from 'src/modules/auth/rematchModels/authentication';
import { countries } from 'src/modules/countries/rematchModels/countries';
import { goalCategories } from 'src/modules/goals/rematchModels/goalCategories';
import { goalInterests } from 'src/modules/goals/rematchModels/goalInterests';
import { languages } from 'src/modules/languages/rematchModels/languages';
import { providers } from 'src/modules/providers/rematchModels/providers';
import { scheduledContent } from 'src/modules/scheduledContent/rematchModels/scheduledContent';
import { user } from 'src/modules/user/rematchModels/user';
import { videoSessions } from 'src/modules/videoSessions/rematchModels/videoSessions';
import { messaging } from 'src/modules/messaging/rematchModels/messaging';

const sentryMiddleware = createSentryMiddleware(Sentry);

const models = {
    authentication,
    providers,
    goalCategories,
    assessments,
    goalInterests,
    user,
    videoSessions,
    countries,
    languages,
    admin,
    scheduledContent,
    messaging,
};

export const initConfig = {
    models,
    redux: {
        middlewares: [sentryMiddleware],
    },
    plugins: [immerPlugin(), loadingPlugin({})],
};

export const store = init(initConfig);

export type Store = typeof store;
export type Dispatch = typeof store.dispatch;
export type RematchModels = RematchRootState<typeof models>;

interface LoadingPlugin {
    loading: {
        models: RematchModels;
        effects: Dispatch;
    };
}
export type RootState = RematchModels & LoadingPlugin;
